import http from '@/services/BackendService'

// ชั้นเดียวที่รู้ URL + response key ของหน้า Markah Komponen (build บน BackendService)
export default {
    // สถานะ komponen ของวิชา — rs = IdHash จาก academicResult/grades (ไม่มีตัวเลขคะแนน)
    async fetchMarkahKomponen(rs) {
        const { data } = await http.get(`academicResult/markahKomponen/${rs}`)
        return data.data
    },
}
